import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 512 512", x: "0px", y: "0px", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M467,211L45,211C20.147,211 0,231.147 0,256C0,280.853 20.147,301 45,301L467,301C491.853,301 512,280.853 512,256C512,231.147 491.853,211 467,211Z" }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
